const getters = {
    token: state => state.user.token,
    roles: state => state.user.roles,
    userInfo: state => state.user.userInfo,
    schoolInfo: state => state.user.schoolInfo,
    permission: state => state.user.permissions, // 权限数据
    isTeacher: () => window.sessionStorage.getItem('classcardManagementIsTeacher') == 1,
    isEmpowerUser: state => state.user.isEmpowerUser,
    empowerUserName: state => state.user.empowerUserName
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js